import React, { useMemo } from 'react';
import cn from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { NicheCardButton } from '../niche-card/niche-card-button/NicheCardButton';
import { NicheCardLink } from '../niche-card/niche-card-link/NicheCardLink';
import type { NicheCardProps } from '../niche-card/NicheCard.types';
import { LINK_IMAGE_SIZE } from '../niche-card/NicheCard.constants';
import type { NicheGridProps } from './NicheGrid.types';
import { NOT_SURE_NICHE } from './NicheGrid.constants';

export const NicheGrid: React.FC<NicheGridProps> = ({
    items,
    className,
    biEventData,
    pageName,
    as = 'link',
    HeaderComponent = null,
}) => {
    const displayItems: NicheCardProps[] = useMemo(() => {
        if (as === 'button') {
            return items;
        }
        return [...items, NOT_SURE_NICHE];
    }, [items, as]);

    const asButton = as === 'button';
    const Component = asButton ? NicheCardButton : NicheCardLink;
    const gap = asButton ? '1' : '8';

    return (
        <Container width="100%" maxWidth="1336px">
            {HeaderComponent}
            <Container
                className={cn(className)}
                display="grid"
                gap={gap}
                style={{
                    gridTemplateColumns: `repeat(auto-fit, minmax(${LINK_IMAGE_SIZE}px, 0fr))`,
                }}
            >
                {displayItems.map((item) => (
                    <Component
                        key={`${item.id}-${item.displayName}`}
                        {...item}
                        {...(biEventData && pageName && { biEventData, pageName })}
                    />
                ))}
            </Container>
        </Container>
    );
};

NicheGrid.displayName = 'NicheGrid';
